<template>
  <div>
    <v-col cols="11" sm="12" md="12">
      <v-row style="padding: 2%" justify="center" align="center">
        <div class="card1">Create Categories</div>
        <div class="card">
          <v-col cols="12" sm="12" md="5" style="padding: 2%">
            <div class="header">Name</div>
            <v-text-field v-model="name" solo outlined dense :rules="nameRules"></v-text-field>
            <div class="header">Upload Image</div>
            <input type="file" accept="image/*" @change="handleFileUpload">
          </v-col>
        </div>
      </v-row>
      <v-row style="padding: 1%; margin-top: -2%">
        <v-col cols="12" sm="3" md="3">
          <v-row>
            <v-btn @click="createCategory()" class="white--text save-btn">{{ buttonText }} Category</v-btn>
            <v-btn @click="goBack()" class="back-btn">Cancel</v-btn>
          </v-row>
        </v-col>
      </v-row>
    </v-col>
    <v-row justify="center">
      <v-overlay :value="loading" style="z-index: 999">
        <v-progress-circular :size="100" color="#008080" indeterminate></v-progress-circular>
      </v-overlay>
    </v-row>
  </div>
</template>

<script>
import { addDoc, collection, getFirestore } from "firebase/firestore";
import { getStorage, ref, uploadBytes, getDownloadURL } from "firebase/storage";

const db = getFirestore();
const storage = getStorage();

export default {
  name: "App",
  data() {
    return {
      loading: false,
      name: "",
      image: null,
      nameRules: [
        (v) => !!v || "Name is required",
        (v) => /^[a-zA-Z ]*$/.test(v) || "Name can only contain letters",
      ],
      buttonText: "Create",
    };
  },
  methods: {
    async createCategory() {
      if (!this.validateForm()) return;

      this.loading = true;

      try {
        const categoryeData = {
          name: this.name,
          imageUrl: null, // Will be updated after uploading the image
        };

        if (this.image) {
          // Perform image upload if an image is selected
          const imageName = new Date().getTime() + "_" + this.image.name;
          const imageStorageRef = ref(storage, "images/" + imageName); // Creating a reference to the storage path
          await uploadBytes(imageStorageRef, this.image); // Uploading the image
          const imageUrl = await getDownloadURL(imageStorageRef); // Getting the download URL
          categoryeData.imageUrl = imageUrl;
        }

        await addDoc(collection(db, "Category"), categoryeData);

        // Clear input fields after successful save
        this.name = "";
        this.image = null;

        this.loading = false;
        // Navigate to templateName component and pass tempName as parameter
        this.$router.push({ name: 'catergory', params: { Name: this.name } });

      } catch (error) {

        this.loading = false;
        console.error("Error saving catergory:", error);
        // Handle error here
      }
    },
    validateForm() {
      // Implement form validation if needed
      return true; // For now, assuming the form is always valid
    },
    goBack() {
      // Implement navigation logic to go back
    },
    handleFileUpload(event) {
      this.image = event.target.files[0];
    },
  },
};
</script>

<style scoped>
.back-btn {
  background-color: grey;
  color: white;
  border-radius: 20px;
}

.confirm-btn {
  background: linear-gradient(0deg,
      rgba(0,129,128,255) 0%,
      rgba(0,129,128,255) 100%);
  border-radius: 20px;
  width: 40%;
  margin-top: -15%;
}

.cancel-btn {
  box-shadow: 0px 0px 0px 1px black;
  border-radius: 20px;
  width: 40%;
  margin-top: -15%;
}

.save-btn {
  background: rgb(23, 74, 133);
  background: linear-gradient(0deg,
      rgba(0,129,128,255) 0%,
      rgba(0,129,128,255) 100%);
  border-radius: 20px;
}

.popup-heading-text {
  background-color: white;
  width: 100%;
  height: 300px;
  font-size: 18px;
  font-weight: bold;
  padding: 20%;
}

.card1 {
  box-shadow: 0px 0px 0px 1px black;
  background-color: #005157;
  /* height:50px; */
  width: 100%;
  border-radius: 12px 12px 0px 0px;
  color: white;
  text-align: center;
  padding: 15px;
}

.card {
  box-shadow: 0px 0px 0px 1px #005157;
  width: 100%;
  border-radius: 0px 0px 12px 12px;
  text-align: center;
}

.header {
  text-align: left;
}

.v-text-field {
  min-height: "20px";
  height: 70px;
}

.v-btn {
  margin-left: 2%;
}

.white--text {
  background: linear-gradient(0deg,
      rgba(0,129,128,255) 0%,
      rgba(0,129,128,255) 100%);
}
</style>
